import React, { useState } from 'react';
import { Modal, Form, Button, Stack } from 'react-bootstrap';
import Creatable from 'react-select/creatable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import { TagWithVideoCountViewModel } from '../apiClient';
import { getReactSelectStyles } from '../helpers/reactSelectTheme';

type AddTagModalProps = {
    show: boolean;
    onHide: () => void;
    onSubmit: (tagName: string) => void;
    availableTags: TagWithVideoCountViewModel[];
};

export const AddTagModal: React.FC<AddTagModalProps> = ({ show, onHide, onSubmit, availableTags }) => {
    const [selectedTagName, setSelectedTagName] = useState<string | null>(null);

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        if (selectedTagName) {
            onSubmit(selectedTagName);
            setSelectedTagName(null); // Reset input after submission
            onHide(); // Close modal after submission
        }
    };

    const tagOptions = availableTags.map(tag => ({ value: tag.name!, label: tag.name! }));

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title><FontAwesomeIcon icon={faTag} /> Add tag</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Stack gap={3}>
                        <Creatable
                            value={selectedTagName ? { value: selectedTagName, label: selectedTagName } : null}
                            options={tagOptions}
                            onChange={selectedOption => setSelectedTagName(selectedOption?.value ?? null)}
                            onCreateOption={value => setSelectedTagName(value)}
                            placeholder="Select or create a tag..."
                            isClearable
                            isSearchable
                            styles={getReactSelectStyles()}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            menuPosition="fixed"
                        />
                        <Button type="submit" disabled={!selectedTagName}>Add Tag</Button>
                    </Stack>
                </Form>
            </Modal.Body>
        </Modal>
    );
};
